module.exports = __webpack_public_path__ + "assets/images/logo-chinese.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo-chinese.png
 ** module id = 23
 ** module chunks = 0
 **/